var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips_box"},[_c('div',{staticClass:"tips_content",domProps:{"innerHTML":_vm._s(_vm.content)}},[_vm._v(" "+_vm._s(_vm.content)+" ")]),_c('p',{staticClass:"tips"},[_vm._v(" "+_vm._s(_vm.$t('toast.bannerGameTxt3')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }